import { useState, useEffect } from 'react';

export const useAuth = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const userData = localStorage.getItem('user_data');

        if (token && userData) {
            try {
                setUser(JSON.parse(userData));
            } catch (error) {
                console.error('Error parsing user data:', error);
                logout();
            }
        }
        setLoading(false);
    }, []);

    const login = (userData, token) => {
        localStorage.setItem('token', token);
        localStorage.setItem('user_data', JSON.stringify(userData));
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_data');
        setUser(null);
    };

    const isAuthenticated = () => {
        return !!localStorage.getItem('token');
    };

    const getUser = () => {
        return user;
    };

    const updateUser = (updatedData) => {
        const currentUser = getUser();
        const newUserData = { ...currentUser, ...updatedData };
        localStorage.setItem('user_data', JSON.stringify(newUserData));
        setUser(newUserData);
    };

    return {
        user,
        loading,
        login,
        logout,
        isAuthenticated,
        getUser,
        updateUser
    };
};